<template>
  <div class="container">

    <div class="mt-2" style="background-color: white; padding: 10px">
      <h4>Edit Zone</h4>
      <p>Project - {{ projectDetails.code }}</p>
      <b-form @submit.prevent="updateZoneForm" enctype="multipart/form-data">
        <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
        <div class="row">
          <div class="col-md-12">
            <b-form-group id="input-group-2" label="Code:" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="zone_form.code"
                placeholder="Enter Zone Code"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="Total area:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                type="text"
                v-model="zone_form.area"
                placeholder="Enter Total area (In Acres)"
                required
              ></b-form-input>
            </b-form-group>
            <div class="row">
              <div class="col-md-6">
                <h5>Boundaries</h5>
              </div>
              <div class="col-md-6 mb-2 text-right">
                <button
                  class="btn btn-sm btn-primary"
                  type="button"
                  @click="addZoneBoundary"
                >
                  New Boundary
                </button>
              </div>
              <div class="col-md-12">
                <table class="table table-sm">
                  <thead class="small thead-light">
                    <tr>
                      <th>#</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(boundary, index) in zone_form.boundaries"
                      :key="index"
                    >
                      <td class="small align-middle">{{ index + 1 }}</td>
                      <td>
                        <b-form-input
                          id="input-2"
                          v-model="boundary.latitude"
                          size="sm"
                          placeholder="Enter Latitude"
                          required
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          id="input-2"
                          v-model="boundary.longitude"
                          size="sm"
                          placeholder="Enter Longitude"
                          required
                        ></b-form-input>
                      </td>
                      <td>
                        <button
                          class="btn btn-sm btn-danger"
                          type="button"
                          @click="removeZoneBoundary(index)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <button class="btn btn-primary">Update</button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      projectDetails: "",
      zone_form: {
        code: "",
        area: "",
        boundaries: [],
      },
      success: false,
    };
  },
  mounted() {
    this.getZoneDetails();
  },
  methods: {
    getZoneDetails() {
      let zone_id = this.$route.params.zone_id;
      window.axios.get("zone/" + zone_id).then((resp) => {
        let data = resp.data.data;
        this.zone_form.code = data.code;
        this.zone_form.area = data.area;
        this.zone_form.boundaries = data.boundaries;
        this.projectDetails = data._projectId;
      });
    },
    addZoneBoundary() {
      this.zone_form.boundaries.push({
        latitude: "",
        longitude: "",
      });
    },
    removeZoneBoundary(index) {
      this.zone_form.boundaries.splice(index, 1);
    },
    updateZoneForm() {
      let zone_id = this.$route.params.zone_id;
      let { code, area, boundaries } = this.zone_form;
      window.axios
        .put("zone/" + zone_id, {
          code,
          area,
          boundaries,
        })
        .then((resp) => {
          console.log(resp);
          let data = resp.data;
          console.log(data);
          if(data.success){
            this.success = data.message
            setTimeout(()=> {
                this.success = false;
            },2000)
          }
        });
    },
  },
};
</script>
